import type { CosmosConfig } from "../entities/cosmos"

export default function loadConfig(config: CosmosConfig): void {
  const root = document.documentElement
  const primaryColorsMap = config.colors.primary
  const primaryColor = primaryColorsMap["500"]

  // Primary colors.
  root.style.setProperty("--primary", primaryColor)

  for (const [key, value] of Object.entries(primaryColorsMap)) {
    const varName = `--primary-${key}`
    root.style.setProperty(varName, value)
  }

  // Alternative colors.
  config.colors.alternatives.forEach((color, index) => {
    const varName = `--alternative-${index}`
    root.style.setProperty(varName, color)
  })

  // Charts (based on the primary colors).
  root.style.setProperty("--chart-1", primaryColor)
  root.style.setProperty("--chart-2", primaryColorsMap["300"])
  root.style.setProperty("--chart-3", primaryColorsMap["400"])
  root.style.setProperty("--chart-4", primaryColorsMap["200"])
  root.style.setProperty("--chart-5", primaryColorsMap["700"])

  // Ring.
  root.style.setProperty("--ring", primaryColor)

  // Sidebar.
  root.style.setProperty("--sidebar-ring", primaryColor)

  // Title.
  document.title = config.meta.title

  // Favicon.
  const favicon = document.querySelector("link[rel='icon']")

  if (favicon) {
    favicon.setAttribute("href", config.meta.faviconUrl)
  }
}
